import { fetchAuthSession } from '@aws-amplify/auth';

import { LocalStorageKeys } from '../constants';

export function useRefreshToken() {
  const refreshToken = async (callbackFn: () => void) => {
    try {
      const refreshTokenResponse = await fetchAuthSession({
        forceRefresh: true,
      });
      const accessToken = refreshTokenResponse.tokens?.accessToken;

      localStorage.setItem(
        LocalStorageKeys.AccessToken,
        accessToken.toString()
      );
      return callbackFn();
    } catch (error) {
      throw new Error('Unable to refresh token and retry request');
    }
  };

  return refreshToken;
}
